import {
  BuildingOfficeIcon,
  FileTextIcon,
  FolderSimpleIcon,
  HouseIcon,
  ScrollIcon,
  SparkleIcon,
  StackIcon,
  UsersIcon,
  WarningOctagonIcon,
  type XIcon,
} from "@phosphor-icons/react/dist/ssr";

import { NAV_SLUG_PERMISSIONS } from "@/constants/navigation";
import type { Permission, Role } from "@/lib/permissions";
import { NavigationSlug } from "@/types";

export const navItems: {
  icon: typeof XIcon;
  slug: NavigationSlug;
  href: string;
  permission: Permission;
}[] = [
  { icon: HouseIcon, slug: "home_projects", href: "/", permission: "page:home" },
  { icon: StackIcon, slug: "evidence", href: "/evidence", permission: "page:evidence" },
  { icon: WarningOctagonIcon, slug: "issue", href: "/issue", permission: "page:issue" },
  {
    icon: SparkleIcon,
    slug: "ai_diagnostic",
    href: "/ai-diagnostic",
    permission: "page:ai_diagnostic",
  },
  { icon: FileTextIcon, slug: "report", href: "/report", permission: "page:report" },
  { icon: UsersIcon, slug: "users", href: "/users", permission: "page:users" },
  {
    icon: BuildingOfficeIcon,
    slug: "organizations",
    href: "/organizations",
    permission: "page:organization",
  },
  { icon: FolderSimpleIcon, slug: "projects", href: "/projects", permission: "page:projects" },
  { icon: ScrollIcon, slug: "standards", href: "/standards", permission: "page:standards" },
];

export function permissionsFromNavigation(items: string[]): Permission[] {
  const known = items.filter((s): s is NavigationSlug => s in NAV_SLUG_PERMISSIONS);
  return [...new Set(known.flatMap((slug) => NAV_SLUG_PERMISSIONS[slug]))];
}

export function fallbackNavigationSlugsForRole(role: Role): NavigationSlug[] {
  switch (role) {
    case "ev":
      return ["home_avi", "evidence", "issue", "report"];
    case "le":
      return ["home_avi", "evidence", "issue"];
    case "pm":
      return ["home_projects", "home_avi", "evidence", "issue"];
    case "ma":
    case "ca":
      return ["home_projects"];
    default:
      return [];
  }
}
